module.exports = __webpack_public_path__ + "media/images/common/search/icon-flag-e7fc4e102d3e465db045b9ad4d7b07f4.png";